<template>
  <!-- eslint-disable max-len -->
  <svg
    width="70px"
    height="60px"
    viewBox="0 0 64 54"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Business</title>
    <desc>Business</desc>
    <defs>
      <polygon
        points="0.0446511628 0.263405769 63.4924651 0.263405769 63.4924651 47.3538462 0.0446511628 47.3538462"
      />
    </defs>
    <g
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g>
        <path
          d="M42.3896104,9.13846154 L39.0259997,9.13846154 L39.0259997,3.31102629 L24.1420958,3.31102629 L24.1420958,9.13846154 L20.7792208,9.13846154 L20.7792208,2.42079411 C20.7792208,1.08580801 21.8798248,0 23.2364517,0 L39.9338509,0 C41.287535,0 42.3896104,1.08580801 42.3896104,2.42079411 L42.3896104,9.13846154"
          fill="#999999"
        />
        <g
          transform="translate(0.000000, 6.646154)"
        >
          <mask
            fill="white"
          >
            <use xlink:href="#path-1" />
          </mask>
          <g />
          <path
            d="M57.0649302,24.6143813 L57.0649302,41.9429293 L6.42827907,41.9429293 L6.42827907,24.6143813 L2.72,24.6143813 C2.05693023,24.6143813 1.45562791,24.370213 0.985302326,23.9758442 L0.985302326,44.6480178 C0.985302326,46.1418837 2.2027907,47.3538462 3.7067907,47.3538462 L59.7856744,47.3538462 C61.2889302,47.3538462 62.5071628,46.1418837 62.5071628,44.6480178 L62.5071628,23.9758442 C62.0346047,24.370213 61.4355349,24.6143813 60.7709767,24.6143813 L57.0649302,24.6143813"
            fill="#999999"
            mask="url(#mask-2)"
          />
          <path
            d="M60.7709767,0.263405769 L2.72148837,0.263405769 C1.21823256,0.263405769 0,1.47610817 0,2.96997404 L0,21.9070731 C0,22.7424245 0.38772093,23.4793687 0.985302326,23.9758442 C1.45562791,24.370213 2.05693023,24.6136413 2.72148837,24.6136413 L27.6293953,24.6136413 L27.6293953,20.7646615 C27.6293953,20.5019957 27.7484651,20.2696659 27.9285581,20.1039274 L4.53655814,20.1039274 L4.53655814,4.77385962 L58.9566512,4.77385962 L58.9566512,20.1039274 L35.563907,20.1039274 C35.744,20.2696659 35.8630698,20.5019957 35.8630698,20.7646615 L35.8630698,24.6136413 L60.7709767,24.6136413 C61.4355349,24.6136413 62.036093,24.370213 62.5071628,23.9758442 C63.1047442,23.4793687 63.4924651,22.7424245 63.4924651,21.9070731 L63.4924651,2.96997404 C63.4924651,1.47610817 62.2757209,0.263405769 60.7709767,0.263405769"
            fill="#999999"
            mask="url(#mask-2)"
          />
        </g>
        <path
          d="M28.9667088,32.6260975 L35.0310043,32.6260975 L35.0310043,28.0207852 L28.9667088,28.0207852 L28.9667088,32.6260975 Z M35.5478606,34.8923077 L28.7128545,34.8923077 C27.5457349,34.8923077 26.5974026,33.9848031 26.5974026,32.8702855 L26.5974026,27.7773262 C26.5974026,26.6606218 27.5457349,25.7538462 28.7128545,25.7538462 L35.2879078,25.7538462 C36.4535028,25.7538462 37.4025974,26.6606218 37.4025974,27.7773262 L37.4025974,33.1203048 C37.4025974,34.0955989 36.5701385,34.8923077 35.5478606,34.8923077 L35.5478606,34.8923077 Z"
          fill="#999999"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SvgBusiness',
};
</script>
